<template>
  <div class="flex gap-2">
    <div>
      <MediaImage
        v-bind="teaserData?.media"
        responsive-style="column_fifth"
        class="min-w-14 max-w-28 shrink-0"
      />
    </div>
    <div class="font-bold line-clamp-2 min-w-28">
      {{ teaserData?.title }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphTeaserFragment } from '#graphql-operations'
import { buildTeaserProps } from './helper'

const props = defineProps<ParagraphTeaserFragment>()

const teaserData = computed(() => buildTeaserProps(props))
</script>
